import { Sparkles } from "lucide-react";
import { fmt, timeOf } from "../lib/format";
import { GradeBadge } from "./GradeBadge";

export const SignalLog = ({ signals }) => {
  if (!signals?.length)
    return <div className="flex-1 flex items-center justify-center text-zinc-600 text-xs">No signals yet — start the agent</div>;
  return (
    <div className="flex-1 min-h-0 overflow-auto thin-scroll divide-y divide-zinc-800/70">
      {signals.map((s) => {
        const active = (s.components || []).filter((c) => c.active);
        const long = s.direction === "LONG";
        return (
          <div key={s.id} data-testid={`signal-${s.id}`} className="px-3 py-2">
            <div className="flex items-center justify-between">
              <div className="flex items-center gap-2">
                <span className={`px-1.5 py-0.5 text-[10px] font-bold rounded-sm ${long ? "text-green-500 bg-green-500/10" : "text-red-500 bg-red-500/10"}`}>
                  {s.direction}
                </span>
                <span className="font-mono text-[13px] font-bold text-zinc-100">{s.symbol}</span>
                <span className="font-mono text-[11px] text-zinc-400">@ {fmt(s.price)}</span>
                <span className="font-mono text-[10px] text-zinc-500">×{s.qty}</span>
              </div>
              <div className="flex items-center gap-2">
                <GradeBadge grade={s.grade} />
                {s.rr != null && <span className="font-mono text-[10px] text-zinc-400">{s.rr}R</span>}
                <span className="font-mono text-[11px] font-bold text-blue-400">{s.score}/{s.threshold}</span>
                <span className="font-mono text-[10px] text-zinc-500">{timeOf(s.ts)}</span>
              </div>
            </div>
            <div className="flex flex-wrap gap-1 mt-1.5">
              {active.map((c, i) => (
                <span key={i} className="px-1 py-[1px] text-[9px] rounded-sm bg-zinc-800 text-zinc-300 border border-zinc-700/60">
                  {c.name.replace("Support/Resistance", "S/R").replace("Market Trend Alignment", "Trend").replace("Fair Value Gap", "FVG").replace("Supply/Demand Zone", "S/D")} +{c.weight}
                </span>
              ))}
            </div>
            <div className="flex gap-3 mt-1.5 font-mono text-[10px] text-zinc-500">
              <span>SL <span className="text-red-500">{fmt(s.stop_loss)}</span></span>
              <span>TP <span className="text-blue-400">{fmt(s.take_profit)}</span></span>
            </div>
            <div className="mt-1.5 flex items-start gap-1.5 rounded-sm border border-blue-500/25 bg-blue-500/5 px-2 py-1.5">
              <Sparkles size={12} className="text-blue-400 mt-0.5 shrink-0" />
              <p className="text-[10.5px] leading-relaxed text-blue-100/80">
                {s.commentary || <span className="text-zinc-500 italic">Generating analysis…</span>}
              </p>
            </div>
          </div>
        );
      })}
    </div>
  );
};
